<template>
    <div id="main">
        <div class="page page-container">
            <loader v-if="isLoading" />
            <alert-container :messages="msgs" />
            <div class="novo-fasefenologica">
                <h1 class="title">
                    {{ $t(`${abrev}-fasefenologica`) }}
                </h1>
                <nav class="breadcrumb" aria-label="breadcrumbs">
                    <ul>
                        <li>
                            <a class="a-inativo">{{ isAgro ? $t('agro') : $t('vendas') }}</a>
                        </li>
                        <li>
                            <a class="a-inativo">{{ isAgro ? $t('agro-cadastros') : $t('crm') }}</a>
                        </li>
                        <li>
                            <a @click="$router.push({ name: `${abrev}-fasefenologica` })">{{
                                $t(`${abrev}-fasefenologica`)
                            }}</a>
                        </li>
                        <li>
                            <a aria-current="page">{{
                                $route.params.id ? $route.params.descricao : $t('novo')
                            }}</a>
                        </li>
                    </ul>
                </nav>
                <br />
                <div class="form-columns-fit">
                    <div class="columns is-flex-wrap">
                        <div class="column is-2">
                            <v-input
                                :id="generateId(3)"
                                ref="idagrofasefenologicaerpInput"
                                v-model="fasefenologica.idagrofasefenologicaerp"
                                placeholder="placeholder-preencha"
                                :maxlength="30"
                                title="codigo"
                                uppercase
                                :required="isUpdate"
                                :invalid="isUpdate && isNull(fasefenologica.idagrofasefenologicaerp)"
                                :tooltipLabel="isUpdate ? 'regra-prefixo-GA-edicao' : 'regra-prefixo-GA-criacao'"
                            />
                        </div>
                        <div class="column is-8">
                            <v-input
                                :id="generateId(1)"
                                ref="descricaoInput"
                                v-model="fasefenologica.descricao"
                                placeholder="placeholder-preencha"
                                :maxlength="50"
                                :title="'descricao'"
                                :msg="'msg-campo-obrigatorio'"
                                :invalid="!fasefenologica.descricao"
                                uppercase
                                tooltipLabel="fase-fenologica-tooltip-descricao"
                                tooltipSize="is-small"
                                :tooltipMultilined="true"
                                tooltipPosition="is-right"
                                :required="true"
                                :disabled="
                                    (isUpdate && !permissao.update) ||
                                    (!allowedUpdate && !allowedCreate)
                                "
                            />
                        </div>

                        <div class="column is-2">
                            <vss-select
                                :id="generateId(2)"
                                ref="situacaoSelect"
                                :searchable="false"
                                :options="situacoes"
                                v-model="situacao"
                                class="no-clear"
                                :mlLabels="true"
                                tooltipLabel="fase-fenologica-tooltip-situacao"
                                tooltipSize="is-small"
                                title="situacao"
                                :tooltipMultilined="true"
                                :disabled="
                                    (isUpdate && !permissao.update) ||
                                    (!allowedUpdate && !allowedCreate)
                                "
                            />
                        </div>
                    </div>
                </div>
                <div class="form-buttons">
                    <button
                        class="delete-btn"
                        type="button"
                        @click="$router.push({ name: `${abrev}-fasefenologica` })"
                    >
                        {{ $t('voltar') }}
                    </button>
                    <button
                        v-if="allowedUpdate || allowedCreate"
                        class="save-btn"
                        type="button"
                        @click="saveFaseFenologica()"
                        :disabled="isSaving"
                    >
                        {{ $t('salvar') }}
                        <button-loader :isSaving="isSaving" />
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import FaseFenologicaService from '@/services/FaseFenologicaService';
import FaseFenologicaValidation from '@/services/validations/agro/FaseFenologicaValidation';
import Message from '@/models/Message';

/* @71139 */
export default {
    data() {
        return {
            faseFenologicaIntegracao: this.$store.state.user.tabelasERPWebServer.includes(
                'AGRO_FASEFENOLOGICA'
            ),
            isLoading: false,
            isSaving: false,
            fasefenologica: {
                idagrofasefenologica: null,
                idagrofasefenologicaerp: null,
                descricao: '',
                situacao: null,
            },
            editable: false,
            title: '',
            msgs: [],
            permissao: {},
            isUpdate: false,
            allowedCreate: false,
            allowedUpdate: false,
            situacoes: [
                { label: 'inativo', id: 0 },
                { label: 'ativo', id: 1 },
            ],
            situacao: { label: 'ativo', id: 1 },

            abrev: this.$route.meta.contexto.slice(0, 3),
            isVenda: this.$route.meta.contexto == 'vendas',
            isAgro: this.$route.meta.contexto == 'agro',
            originalIdErp: ''
        };
    },
    created() {
        this.isUpdate = this.$route.params.id != null && this.$route.params.id != 'new';

        if (this.isAgro) {
            this.abrev = this.$route.meta.contexto.slice(0, 4);
            this.permissao = this.hasPermissionAccess(
                'agro',
                'agro-cadastros',
                'agro-fasefenologica'
            );
        } else if (this.isVenda) {
            this.permissao = this.hasPermissionAccess('vendas', 'crm', 'ven-fasefenologica');
        }

        if (!this.isUpdate && !this.permissao.create) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: `${this.abrev}-fasefenologica` },
            });
        }

        if (this.fasefenologica != null && this.fasefenologica != {}) {
            this.editable = true;
        }

        this.service = new FaseFenologicaService(this.$http, this.$router);
        this.validation = new FaseFenologicaValidation(this.msgs);

        this.allowedCreate =
            !this.isUpdate && this.permissao.create && !this.faseFenologicaIntegracao;

        this.allowedUpdate =
            this.isUpdate && this.permissao.update && !this.faseFenologicaIntegracao;

        if (this.$route.params.id) {
            this.editable = false;
            this.carregarDados(this.$route.params.id);
        }
    },
    mounted() {
        this.$refs.descricaoInput.$refs.typed.focus();
    },
    methods: {
        generateId(numberId) {
            return this.$route.name + '-' + numberId;
        },
        carregarDados(id) {
            this.isLoading = true;

            this.service
                .find(id, this.abrev)
                .then((body) => {
                    if (body.content) {
                        this.fasefenologica = body.content;
                        this.originalIdErp = this.fasefenologica.idagrofasefenologicaerp;
                        this.situacao = this.situacoes[this.fasefenologica.situacao];
                        this.title = this.fasefenologica.descricao;
                    } else {
                        this.$router.push({ name: `${this.abrev}-fasefenologica-new` });
                    }
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        saveFaseFenologica() {
            this.fasefenologica.situacao = this.situacao.id;
            this.fasefenologica = this.mapTosave(this.fasefenologica);

            if (this.validation.validate(this.fasefenologica, this.$refs)) {
                if(this.isPrefixSovisInIdErpInvalid(this.fasefenologica.idagrofasefenologicaerp || '', this.originalIdErp)) {
                    const message = 
                        this.isUpdate ? 'nao-permitido-prefixo-ga-alterar' : 'nao-permitido-prefixo-ga-no-campo-codigo';

                    return this.$root.showMessage('alert', message, true);
                }

                this.isSaving = true;
                this.service
                    .save(this.fasefenologica, this.abrev)
                    .then((body) => {
                        if (body.content) {
                            let msg = 'msg-fasefenologica-salva';
                            if (this.fasefenologica.idagrofasefenologica) {
                                msg = 'msg-fasefenologica-edita';
                            }
                            this.fasefenologica = body.content;
                            this.originalIdErp = this.fasefenologica.idagrofasefenologicaerp;
                            this.msgs.push(new Message('success', msg, true));
                            this.redirectToPage();
                        } else {
                            if (this.$te(body.message)) {
                                if (body.message == 'msg-codigo-duplicado-n') {
                                    this.msgs.push(
                                        new Message(
                                            'alert',
                                            this.$t(body.message, 
                                                { n: this.fasefenologica.idagrofasefenologicaerp }
                                            ),
                                            true,
                                            false
                                        )
                                    );
                                } else {
                                    this.msgs.push(new Message('alert', body.message, true));
                                }
                            } else {
                                if (this.$t(body.message)) {
                                    this.msgs.push(new Message('alert', body.message, true));
                                } else {
                                    this.msgs.push(
                                        new Message('error', 'msg-problema-realizar-acao', true)
                                    );
                                }
                            }
                        }
                    })
                    .catch(() => {
                        this.msgs.push(new Message('error', 'msg-problema-realizar-acao', true));
                    })
                    .finally(() => {
                        this.isSaving = false;
                    });
            } else {
                this.$root.showMessage('alert', 'msg-campos-obrigatorios', true);
            }
        },
        redirectToPage() {
            this.isUpdate = true;

            this.$router.push({
                name: `${this.abrev}-fasefenologica-edit`,
                params: { id: this.fasefenologica.id, descricao: this.fasefenologica.descricao },
            });
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: auto;
}
.page {
    position: relative;
    margin-bottom: 40px;

    .novo-fasefenologica {
        position: relative;
        width: 100%;
        margin-bottom: 20px;
        height: 100%;
        padding-top: 0;
        > h1 {
            padding-top: 20px;
            margin-bottom: 40px;
        }
    }
}

.novo-fasefenologica .center {
    width: 100%;
    left: 0;
    transform: translateX(0);
    margin: 0;
    box-sizing: border-box;
    position: initial;
    padding-bottom: 20px;
}

.form-buttons {
    right: 0;
}

@media only screen and (min-width: 760px) {
    nav.breadcrumb {
        margin-right: 410px;
    }
}

.novo-fasefenologica .form {
    // display: block;
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    border-radius: 2px;
    text-align: left;
    .location {
        width: 100%;
        height: auto;
        flex: 1 1 auto;
        margin-top: 20px;
        position: relative;
        min-height: 300px;
        height: auto;
        margin-bottom: 20px;

        .getlocation {
            position: absolute;
            margin-left: 0;
            bottom: -60px;
        }
    }
}
</style>
